import React, { useState, useEffect } from "react";
import _ from "lodash";

// icons
import SearchIcon from "@mui/icons-material/Search";
import ReactPaginate from "react-paginate";

// aollo
import { GET_EXCHANGE_RATE, GET_PRODUCTS } from "../../apollo/product/query";
import { GET_PRODUCT_VARIANTS } from "../../apollo/productVariant/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { GET_BRANDS } from "../../apollo/brand/Query";
import { GET_SUBBRANDS } from "../../apollo/subbrand/query";

// bootrap
import { Form, InputGroup, Table } from "react-bootstrap";
import PaginationHelper from "../../components/PaginationHelper";
import { convertCurrency, HandleCurrency, numberFormat } from "../../helper";
import { LINEAR_GRADIENT_BG, SHOP_SETTING_KEY, USER_KEY } from "../../const";
import CustomButton from "../../components/CustomButton";
import { errorSwal, successSwal } from "../../helper/sweetalert";
import { GET_GEN_CODE_ORDER_GROUP } from "../../apollo/ordergroup/query";
import PurchaseModal from "./PurchaseModal";
import { CREATE_MANY_PURCHASE_ORDER_AND_PURCHASE_ORDER_DETAIL, CREATE_MANY_PURCHASE_V2 } from "../../apollo/purchaseOrder/Mutation";
import EmptyComponent from "../../components/EmptyComponent";
import AnimationLoading from "../../components/Animationloading";

export default function PurchaseOrders({
  _purchaseOrderDetail,
  purchaseOrderdetailData,
}) {
  const currentCategory = localStorage.getItem("CURRENT_CATEGORY");
  const currentBrand = localStorage.getItem("CURRENT_BRAND");
  const currentSubBrand = localStorage.getItem("CURRENT_SUBBRAND");
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [category, setCategory] = useState();
  const [subBrand, setSubBrand] = useState();
  const [brand, setBrand] = useState();
  const [selectCategory, setSelectCategory] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchBrand, setSearchBrand] = useState(currentBrand);
  const [searchCategory, setSearchCategory] = useState(currentCategory);
  const [searchSubbrand, setSearchSubbrand] = useState(currentSubBrand);

  const [showOrderModal, SetshowOrderModal] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [variantPageNumber, setVariantPageNumber] = useState(1);
  const LIMIT_PAGE = 30;
  const [activeProductTab, setActiveProductTab] = useState("PRODUCT");

  // ==========> state For Add to card
  const [selectedPrice, setSelectedPrice] = useState(0);
  const selectedPayCurrency = "LAK";
  const [products, setProducts] = useState([]);
  const [originProducts, setOriginProducts] = useState([]);
  const [variantProducts, setVariantProducts] = useState([]);
  const [originVariantProducts, setOriginVariantProducts] = useState([]);
  const [totalProduct, setTotalProduct] = useState(0);
  const [totalVariantProduct, setTotalVariantProduct] = useState(0);
  const [cartDatas, setCartDatas] = useState([]);
  const [activeCart, setActiveCart] = useState("Bill 1");
  const [exchangeRate, setExchangeRate] = useState(() => {
    try {
      const savedRate = localStorage.getItem("EXCHANGE_RATE");
      return savedRate ? JSON.parse(savedRate) : {};
    } catch (error) {
      return {};
    }
  });
  const [gencodeordergroup, setGenCodeOrderGroup] = useState();
  const [totalAmount, setTotalAmount] = useState(0);
  const [change, setChange] = useState(0);
  const [receivedMoney, setReceivedMoney] = useState(0);
  const [activeTab, setActiveTab] = useState("ເງິນສົດ");
  const [offerPrice, setOffePrice] = useState();

  const [showPriceOptionModal, setShowPriceOptionModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  // const [selectedProductPrice, setSelectedProductPrice] = useState(0);
  // Paggination helper
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  // Apollo

  const [getProductDatas, { data: productDatas, loading: productLoading }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "cache-and-network" });

  const [
    loadProductVariants,
    { data: productVariantData, loading: productVariantLoading },
  ] = useLazyQuery(GET_PRODUCT_VARIANTS, { fetchPolicy: "cache-and-network" });

  const [
    getExchangeRate,
    { data: exchangeRateData, loading: exchangeRateLoading },
  ] = useLazyQuery(GET_EXCHANGE_RATE, { 
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data?.exchangeRate) {
        setExchangeRate(data.exchangeRate);
        localStorage.setItem("EXCHANGE_RATE", JSON.stringify(data.exchangeRate));
      }
    }
  });

  // const [LoadGenCode, { data: GetGenCodeData, loading: loadingGenCode }] =
  //   useLazyQuery(GET_GEN_CODE_ORDER_GROUP, { fetchPolicy: "network-only" });

  const [LoadCategory, { data: GetCategoryData, loading: loadingCategory }] =
    useLazyQuery(GET_CATEGORYS, { fetchPolicy: "network-only" });

  const [LoadBrand, { data: GetBrandData, loading: loadingBrand }] =
    useLazyQuery(GET_BRANDS, { fetchPolicy: "network-only" });

  const [LoadSubBrand, { data: GetSubBrandData, loading: loadingSubBrand }] =
    useLazyQuery(GET_SUBBRANDS, { fetchPolicy: "network-only" });

  const [
    createManyPurchaseOrderWithPurchaseOrderDetail,
    { loading: createPurchaseorderLoading },
  ] = useMutation(CREATE_MANY_PURCHASE_ORDER_AND_PURCHASE_ORDER_DETAIL);
  const [ createManyPurchaseV2, { loading: createManyPurchaseV2Loading }] = useMutation(CREATE_MANY_PURCHASE_V2);

  // useEffcet

  useEffect(() => {
    if (productDatas?.products) {
      // console.log('==================step 1')
      setTotalProduct(productDatas?.products?.total);
      //   const filteredProducts = productDatas?.products?.data.slice((_skip - 1) * _limit, _limit * _skip);
      setProducts(productDatas?.products?.data);
      setOriginProducts(productDatas?.products?.data);
    }
  }, [JSON.stringify(productDatas?.products)]);

  useEffect(() => {
    if (productVariantData?.productVariants) {
      setTotalVariantProduct(productVariantData?.productVariants?.total ?? 0);
      setVariantProducts(productVariantData?.productVariants?.data || []);
      setOriginVariantProducts(productVariantData?.productVariants?.data || []);
    }
  }, [JSON.stringify(productVariantData?.productVariants)]);


    
  useEffect(() => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;
    setTotalAmount(selectedCart?.data?.orderGroup?.amount ?? 0);
    // setTotalPricePay(selectedCart?.data?.orderGroup?.sumPrice ?? 0)
    // _loadGenCode();
  }, [activeCart, JSON.stringify(cartDatas)]);

  // useEffect(() => {
  //   if (GetGenCodeData) {
  //     const number = GetGenCodeData?.orderGroups?.total + 1;
  //     let _genBarCode = number;
  //     if (number <= 9) _genBarCode = "0" + _genBarCode;
  //     else if (number <= 99) _genBarCode = "0" + _genBarCode;
  //     else if (number <= 999) _genBarCode = "0" + _genBarCode;
  //     else if (number <= 9999) _genBarCode = "0" + _genBarCode;
  //     setGenCodeOrderGroup(_genBarCode);
  //   }
  // }, [GetGenCodeData]);

  useEffect(() => {
    if (GetCategoryData) {
      const result = (GetCategoryData?.categories?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setCategory(result);
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) {
      const result = (GetBrandData?.brands?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setBrand(result);
      setSelectCategory(GetBrandData?.brands?.data?.category?.id);
    }
  }, [GetBrandData]);

  useEffect(() => {
    if (GetSubBrandData) {
      const result = (GetSubBrandData?.subBrands?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setSubBrand(result);
    }
    // console.log("subbarnd======", subBrand)
  }, [GetSubBrandData]);

  useEffect(() => {
    _setNewCartData();
    _fetchExchangeRateData();
    // _loadGenCode();
    // filterBrand()

    // TODO: Get all category
    LoadCategory({
      variables: {
        limit: 50,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
    filterBrand();
  }, []);

  useEffect(() => {
    updateOrderGroup();
    // _filter();
  }, [JSON.stringify(cartDatas)]);

  useEffect(() => {
    if (activeProductTab === "PRODUCT") {
      if (searchCategory !== "ALL") {
        filterBrand();
        _filter();
      } else {
        _filter();
      }
    } else {
      _filterVariant();
    }
  }, [
    activeProductTab,
    searchText,
    searchBrand,
    searchCategory,
    selectedPrice,
    _skip,
    pageNumber,
    variantPageNumber,
  ]);

  const _fetchExchangeRateData = async () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    if (!shopId) {
      shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    }

    if (shopId) {
      getExchangeRate({
        variables: {
          where: {
            shop: shopId,
          },
        },
      });
    }
  };

  // const _loadGenCode = async () => {
  //   const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
  //     ?.id;
  //   await LoadGenCode({
  //     variables: {
  //       where: {
  //         shop: shopId,
  //       },
  //     },
  //   });
  // };

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
      // console.log("step 2")
      // console.log("searchCategory", searchCategory)
      _where = { ..._where, category: searchCategory };
    }

    // TODO: Get all brand
    LoadBrand({
      variables: {
        limit: 50,
        where: _where,
      },
    });
  };

  const filterSubBrand = async () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
      _where = { ..._where, brand: searchBrand };
    }

    // TODO: Get all brand
    LoadSubBrand({
      variables: {
        limit: 50,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      // console.log("step 1")
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
        // category: selectCategory
      };

      // TODO: check if search text is not empty
      if (!_.isEmpty(searchText)) {
        _where = { ..._where, name: searchText };
      }

      if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
        const _newSearchBrand = brand.find(({ id }) => id === searchBrand).name;
        _where = { ..._where, brand: searchBrand, brandName: _newSearchBrand };
      }

      if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
        const _newSearchCategory = category.find(({ id }) => id === searchCategory).name;
        _where = { ..._where, category: searchCategory, categoryName: _newSearchCategory };
      }

      if (!_.isEmpty(searchSubbrand) && searchSubbrand !== "ALL") {
        // const _newSearchSubBrand = subBrand.find(({ id }) => id === searchSubbrand).name;
        _where = { ..._where, subbrand: searchSubbrand };
      }

      // TODO: Get all product
      getProductDatas({
        variables: {
          skip: (pageNumber - 1) * LIMIT_PAGE,
          limit: LIMIT_PAGE,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const _filterVariant = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      loadProductVariants({
        variables: {
          skip: (variantPageNumber - 1) * LIMIT_PAGE,
          limit: LIMIT_PAGE,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const _setNewCartData = async () => {
    const shopId = await JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // const number = parseInt(gencodeordergroup);
    // let _genBarCode = number;
    // if (number <= 9) _genBarCode = "0" + _genBarCode;
    // else if (number <= 99) _genBarCode = "0" + _genBarCode;
    // else if (number <= 999) _genBarCode = "0" + _genBarCode;
    // else if (number <= 9999) _genBarCode = "0" + _genBarCode;
    setCartDatas([
      {
        id: 1,
        label: "Bill 1",
        data: {
          orders: [],
          orderGroup: {
            // code:_genBarCode,
            amount: 0,
            totalPrice: 0,
            receivedMoney: 0,
            change: 0,
            sumPriceBaht: 0,
            sumPriceUsd: 0,
            currency: "LAK",
            shop: shopId,
            payment: "CASH",
          },
        },
      },
    ]);
  };

  const adjustStock = ({ productId, delta }) => {
    const updateList = (list, setter) => {
      const index = _.findIndex(list, { id: productId });
      if (index < 0) return false;
      const updated = [...list];
      updated[index] = {
        ...updated[index],
        amount: parseInt(updated[index]?.amount ?? 0) + parseInt(delta),
      };
      setter(updated);
      return true;
    };

    if (updateList(originProducts, setOriginProducts)) return;
    updateList(originVariantProducts, setOriginVariantProducts);
  };

  // Push to an array
  const addOrder = ({ product, productPrice }) => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;

    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // TODO: Check product amount
    // if (product?.amount <= 0) return;
    let amount = 1;
    let totalPrice = 0;
    const price = product?.originPrice || product?.priceOptions?.[0]?.originPrice || 0;
    totalPrice = 
      price ? parseInt(price) * amount :
      (productPrice > 0
        ? productPrice
        : product?.priceOptions[selectedPrice]?.price || 0);

    // TODO: Set new order
    const _currency = HandleCurrency(product?.currency ? product?.currency : "LAK");
    const _newOrder = {
      amount,
      totalAmount: product?.amount ?? product?.originAmount,
      originPrice: product?.originPrice,
      price: price || 0,
      priceOptions: product?.priceOptions,
      productVariant: product?.productVariant,
      stock: product?.stock,
      totalPrice,
      shop: shopId,
      product: product?.id,
      productName: product?.name,
      brand: product?.brand?.name ? product?.brand?.name : product?.brandName,
      category: product?.category?.name ? product?.category?.name : product?.categoryName,
      unit: product?.unitId?.name ? product?.unitId?.name : product?.unit,
      currency: _currency,
    };

    // TODO: Set new cart datas
    const _newCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: { orders: [_newOrder, ...orders], orderGroup },
        };
      }
      return cart;
    });

    // TODO: Set cartDatas state into cart datas
    setCartDatas(_newCartDatas);

    // TODO: Update product quantity
    adjustStock({ productId: product?.id, delta: -amount });
    // _filter();
    return;
  };

  // Update object within an array
  const updateOrder = ({ product, productId, isAdded, changeValue }) => {
    // TODO: Check product quantity
    if (changeValue < 0) return;
    // TODO: Set new orders
    const _newOrders = (cart) =>
      cart?.data?.orders?.map((order) => {
        let amount = order?.amount;
        if (order.product === productId) {
          let totalPrice = order?.totalPrice ?? 0;
          let totalPriceBaht = order?.totalPriceBaht ?? 0;
          let totalPriceUsd = order?.totalPriceUsd ?? 0;

          // TODO: Check order amount and product amount
          // if (isAdded) {
          let stockDelta = 0;

          if (changeValue > 0 || !Number.isFinite(changeValue)) {
            amount = !Number.isFinite(changeValue) ? 0 : changeValue;
            stockDelta = order?.amount - amount;
          } else if (isAdded) {
            amount++;
            stockDelta = -1;
          } else if (!isAdded) {
            amount--;
            stockDelta = 1;
          }

          if (stockDelta !== 0) {
            adjustStock({ productId, delta: stockDelta });
          }

          //ກວດຈຳນວນສັ່ງຊື້ ມີ ຫຼື ບໍ່
          //ຖ້າບໍ່ມີ ໃຫ້ລາຄາເປັນສູນ
          //ຖ້າມີໃຫ້ ເອົາຈຳນວນ ຄູນ ໃຫ້ລາຄາ

          // TODO: Check currency and calculate total price
          totalPrice = amount * order?.originPrice;
          if (order?.currency === "LAK" || order?.currency === "ກີບ")
            totalPrice = amount * order?.originPrice;
          if (order?.currency === "BAHT" || order?.currency === "ບາດ")
            totalPrice = amount * order?.originPrice;
          if (order?.currency === "USD" || order?.currency === "ໂດລາ")
            totalPrice = amount * order?.originPrice;
          // }
          return {
            ...order,
            ...{ amount, totalPrice, totalPriceBaht, totalPriceUsd },
          };
        }

        return order;
      });

    // TODO: Set update cart datas
    let _updateCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: _newOrders(cart),
          },
        };
      }
      return cart;
    });

    setCartDatas(_updateCartDatas);
  };

  // TODO: Update order group
  const updateOrderGroup = async () => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;
    const { orders, orderGroup } = selectedCart?.data;
    let totalPrice = 0;
    let sumPriceBaht = 0;
    let sumPriceUsd = 0;
    let amount = 0;
    let sumPrice = 0; // price must pay

    // TODO: Sum amount and price and calculate total price to kip
    orders?.map((order) => {
      amount = amount + order?.amount;
      const price = order.price * order.amount;
      if (order?.currency === "LAK" || order?.currency === "ກີບ") {
        totalPrice = totalPrice + price;
        sumPrice = sumPrice + price;
      }
      if (order?.currency === "BAHT" || order?.currency === "ບາດ") {
        sumPriceBaht = sumPriceBaht + price;
        sumPrice = sumPrice + price * exchangeRate?.baht;
      }
      if (order?.currency === "USD" || order?.currency === "ໂດລາ") {
        sumPriceUsd = sumPriceUsd + price;
        sumPrice = sumPrice + price * exchangeRate?.usd;
      }
    });

    if (["BAHT", "ບາດ"].includes(selectedPayCurrency)) {
      sumPrice = sumPrice / exchangeRate?.baht;
    } else if (["USD", "ໂດລາ"].includes(selectedPayCurrency)) {
      sumPrice = sumPrice / exchangeRate?.usd;
    } else {
      sumPrice = sumPrice;
    }

    const _updatedOrderGroup = {
      ...orderGroup,
      amount,
      totalPrice,
      sumPriceBaht,
      sumPriceUsd,
      sumPrice,
    };
    // return _updatedOrderGroup;

    setCartDatas((preCarts) =>
      preCarts.map((cart) => {
        // console.log({ cart })
        if (cart.label === activeCart) {
          // console.log("=======", { orders })
          return {
            ...cart,
            data: { orders, orderGroup: _updatedOrderGroup },
          };
        }
        return cart;
      })
    );
  };

  // Clear order from cart
  const onClearOrder = (order) => {
    const prevState = cartDatas.map((cart) => {
      return {
        ...cart,
        data: {
          orders: cart?.data?.orders.filter(
            (_order) =>
              _order.product !== order?.product || cart?.label !== activeCart
          ),
        },
      };
    });
    setCartDatas(prevState);

    // TODO: Update product uantity
    // const _productIndex = _.findIndex(products, { id: order?.product });
    adjustStock({ productId: order?.product, delta: order?.amount });
    return;
    // }
  };

  // Select product
  const onSelectProduct = (product) => {
    // if (product?.amount <= 0) return errorSwal(`ສິນຄ້າ  ${product?.title} ໝົດສະຕອັກ`);
    const cartType = getActiveCartType();
    if (cartType === "VARIANT") {
      return errorSwal("ສາມາດເລືອກໄດ້ຢ່າງດຽວ: ສິນຄ້າທົ່ວໄປ ຫຼື ສິນຄ້າຫຼາຍຄ່າ");
    }
    setSelectedProduct(product);

    // TODO: Check cart
    // if (cartDatas?.length <= 0) return errorSwal('ກະລຸນາເພີ່ມໃບບີນ');

    // TODO: Check Product already added to the cart
    let _check = checkedProductSelected(product);

    // TODO: If product has not added then add new product to the cart
    if (!_check) {
      return addOrder({ product, productPrice: 0 });
    }

    // TODO: If product has already added to the cart then update quantity
    if (_check)
      return updateOrder({
        product,
        productId: product?.id,
        isAdded: true,
        changeValue: 0,
      });
  };

  // select priceOptions
  const onSelectOptionPrice = (product) => {
    if (product?.amount <= 0)
      return errorSwal(`ສິນຄ້າ  ${product?.name} ໝົດສະຕອັກ`);
    setSelectedProduct(product);

    // TODO: Check cart
    // if (cartDatas?.length <= 0) return errorSwal('ກະລຸນາເພີ່ມໃບບີນ');

    // TODO: Check Product already added to the cart
    let _check = checkedProductSelected(product);

    // TODO: If product has not added then add new product to the cart
    if (!_check) {
      // TODO: Check price
      if (product?.priceOptions) {
        setShowPriceOptionModal(true);
        return;
      }
      // toast.success(`${product?.title}  ${numberFormat(product?.priceOptions[0]?.price)} ${product?.currency}`, {
      //     position: "top-right",
      //     autoClose: 500,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      // });
    }
    return setShowPriceOptionModal(true);
  };

  // Checked product has selected
  const checkedProductSelected = (product) => {
    let _check = false;
    const cartData = _.find(cartDatas, { label: activeCart });
    cartData?.data?.orders?.map((productId) => {
      if (product?.id === productId?.product) _check = true;
    });
    return _check;
  };

  const formatVariantAttributes = (attributeValues = []) => {
    if (!Array.isArray(attributeValues) || attributeValues.length === 0)
      return "-";
    return attributeValues
      .map((attr) => {
        const name = attr?.attribute?.name || "";
        const value = attr?.value || "";
        return name ? `${name}${value ? `: ${value}` : ""}` : value;
      })
      .filter(Boolean)
      .join(", ");
  };

  const onSelectVariant = (variant) => {
    if (!variant) return;
    const cartType = getActiveCartType();
    if (cartType === "PRODUCT") {
      return errorSwal("ສາມາດເລືອກໄດ້ຢ່າງດຽວ: ສິນຄ້າທົ່ວໄປ ຫຼື ສິນຄ້າຫຼາຍຄ່າ");
    }
    const attributes = formatVariantAttributes(variant?.attributeValues || []);
    const productName = variant?.product?.name ?? "-";
    const variantName = attributes ? `${productName} (${attributes})` : productName;

    const normalizedVariant = {
      id: variant?.id,
      name: variantName,
      amount: variant?.amount ?? 0,
      originAmount: variant?.originAmount,
      originPrice: variant?.originPrice,
      price: variant?.price,
      currency: variant?.currency,
      productVariant: variant?.id,
      stock: variant?.product?._id,
      priceOptions: [],
      brand: { name: variant?.product?.brandName },
      category: { name: variant?.product?.category?.name },
    };

    const hasAdded = checkedProductSelected({ id: variant?.id });

    if (!hasAdded) {
      addOrder({ product: normalizedVariant, productPrice: variant?.price ?? 0 });
    } else {
      updateOrder({
        product: normalizedVariant,
        productId: variant?.id,
        isAdded: true,
        changeValue: 0,
      });
    }
  };

  const filteredVariants = variantProducts
    ?.filter((variant) => {
      if (!searchText) return true;
      const name = variant?.product?.name ?? "";
      const attrs = formatVariantAttributes(variant?.attributeValues || []);
      return (
        name.toLowerCase().includes(searchText.toLowerCase()) ||
        attrs.toLowerCase().includes(searchText.toLowerCase())
      );
    })
    .filter((variant) => {
      if (!searchBrand || searchBrand === "ALL") return true;
      const selectedBrand = brand?.find(({ id }) => id === searchBrand)?.name;
      return variant?.product?.brandName === selectedBrand;
    })
    .filter((variant) => {
      if (!searchCategory || searchCategory === "ALL") return true;
      return variant?.product?.category?.id === searchCategory;
    });

  const filteredProducts = (products || []).filter(
    (product) => !product?.hasVariant
  );

  const handleRemoveCart = async ({ label, isRemove }) => {
    if (!isRemove) return;

    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

    // TODO: Filter order data in cart will remove
    const orderData = _.find(cartDatas, { label });
    const { orders } = orderData?.data;

    const updatedOriginData = originProducts.map((originProduct) => {
      const matchingData = orders.find(
        (order) => order.product === originProduct.id
      );
      return matchingData
        ? {
          ...originProduct,
          amount: matchingData.amount + originProduct.amount,
        }
        : originProduct;
    });

    const updatedOriginVariantData = originVariantProducts.map((originVariant) => {
      const matchingData = orders.find(
        (order) => order.product === originVariant.id
      );
      return matchingData
        ? {
          ...originVariant,
          amount: matchingData.amount + originVariant.amount,
        }
        : originVariant;
    });

    setOriginProducts(updatedOriginData);
    setOriginVariantProducts(updatedOriginVariantData);

    if (cartDatas?.length === 1) {
      // const number = parseInt(gencodeordergroup);
      // let _genBarCode = number;
      // if (number <= 9) _genBarCode = "0" + _genBarCode;
      // else if (number <= 99) _genBarCode = "0" + _genBarCode;
      // else if (number <= 999) _genBarCode = "0" + _genBarCode;
      // else if (number <= 9999) _genBarCode = "0" + _genBarCode;
      setActiveCart("Bill 1");
      return setCartDatas([
        {
          id: 1,
          label: "Bill 1",
          data: {
            orders: [],
            orderGroup: {
              // code: _genBarCode,
              amount: 0,
              totalPrice: 0,
              receivedMoney: 0,
              change: 0,
              sumPriceBaht: 0,
              sumPriceUsd: 0,
              currency: "LAK",
              shop: shopId,
              payment: "CASH",
            },
          },
        },
      ]);
    }

    const _newCartDatas = cartDatas.filter((cart) => cart.label !== label);
    await setCartDatas(_newCartDatas);
    if (activeCart === label) {
      setActiveCart(_newCartDatas[0].label);
    } else {
      setActiveCart(activeCart);
    }
  };

  const onCreateManyPurchaseOrderWithPurchaseOrderDetail = async () => {
    try {
      if (createPurchaseorderLoading || createManyPurchaseV2Loading) return;
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      if (!shopId) {
        shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
      }
      // TODO: Find cart data
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) return;

      // TODO: Get orders and order group
      const { orders, orderGroup } = selectedCart?.data;

      const _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        currency: orders?.[0]?.currency,
        change: parseFloat(change),
        receivedMoney: parseFloat(receivedMoney),
        lot: selectedCart?.lot,
        rateBaht: parseFloat(exchangeRate?.baht || exchangeRateData?.exchangeRate?.baht),
        rateUsd: parseFloat(exchangeRate?.usd || exchangeRateData?.exchangeRate?.usd),
      };

      // TODO: Set new order data
      let _newOfferpriceData = {
        purchaseorders: orders,
        purchaseorderdetail: _updatedOfferPriceGroup
      };

      setOffePrice(_newOfferpriceData);
      // console.log("kkkkkkkkkkkk===>", offerPrice)

      // TODO: Clear total amount, brand, priceOptions, category from orders
      const updatedOfferprices = _newOfferpriceData.purchaseorders.map(
        (order) => {
          const {
            totalAmount,
            priceOptions,
            brand,
            category,
            product,
            ...rest
          } = order;
          return { 
            ...rest, 
            stock: order?.stock ?? order?.product,
            rateBaht: parseFloat(exchangeRate?.baht || exchangeRateData?.exchangeRate?.baht),
            rateUsd: parseFloat(exchangeRate?.usd || exchangeRateData?.exchangeRate?.usd),
          };
        }
      );

      // TODO: Set new orders with order group for send to the backend
      const _newOfferpriceDataWithOfferpriceGroup = {
        ..._newOfferpriceData,
        purchaseorders: updatedOfferprices.reverse(),
      };

      // TODO: Check setting after create purchase
      const setting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
      if (setting?.stockInOut) {
        const result = await createManyPurchaseV2({
          variables: { data: _newOfferpriceDataWithOfferpriceGroup },
        });
        const {status, msg} = JSON.parse(result?.data?.createManyPurchaseV2);
        if (status) {
          successSwal(msg);
        } else {
          return errorSwal(msg);
        }
      } else {
        // TODO: Insert many order and ordergroup
        await createManyPurchaseOrderWithPurchaseOrderDetail({
          variables: { data: _newOfferpriceDataWithOfferpriceGroup },
        });
      }
      SetshowOrderModal(false);
      // fetchProductData()
      // TODO: Clear bill
      _purchaseOrderDetail();
      handleRemoveCart({ label: activeCart, isRemove: false });
      setActiveTab("ເງິນສົດ");
      setChange(0);
      setReceivedMoney("0");
      if (cartDatas?.length <= 1) {
        setCartDatas([
          {
            id: 1,
            label: "Bill 1",
            data: {
              orders: [],
              orderGroup: {
                amount: 0,
                totalPrice: 0,
                receivedMoney: 0,
                change: 0,
                sumPriceBaht: 0,
                sumPriceUsd: 0,
                currency: orders?.[0]?.currency || "LAK",
                shop: shopId,
                payment: "CASH",
                rateBaht: exchangeRate?.baht || exchangeRateData?.exchangeRate?.baht,
                rateUsd: exchangeRate?.usd || exchangeRateData?.exchangeRate?.usd,
              },
            },
          },
        ]);
      }

      // TODO: Show modal success
      return successSwal("ສັ່ງຊື້ສິນຄ້າສຳເລັດ");
    } catch (err) {
      console.log(err?.message);
      errorSwal("ມີຂໍ້ຜິດພາດ");
      return;
    }
  };

  const handleEditPriceProduct = (e, index) => {
    let _converPrice = e?.target?.value.toString().replace(",", "");
    let _price = parseInt(_converPrice);

    const getCartData = cartDatas.filter((item) => item?.label === activeCart);
    let newOrder = [...cartDatas];
    let updatePriceOrder = getCartData[0].data;
    updatePriceOrder.orders[index].price = _price;
    updatePriceOrder.orders[index].totalPrice =
      updatePriceOrder.orders[index].amount * _price;

    setCartDatas(newOrder);
  };

  const getActiveCartType = () => {
    const cartData = _.find(cartDatas, { label: activeCart });
    const orders = cartData?.data?.orders || [];
    if (orders.length === 0) return null;
    const hasVariant = orders.some((order) => order?.productVariant);
    const hasProduct = orders.some((order) => !order?.productVariant);
    if (hasVariant && !hasProduct) return "VARIANT";
    if (hasProduct && !hasVariant) return "PRODUCT";
    return "MIXED";
  };

  return (
    <React.Fragment>
      <div className="purchasorders-main">
        <div style={{ display: "flex", gap: 8, marginBottom: "12px" }}>
          <CustomButton
            height={36}
            width={180}
            borderRadius={8}
            title="ສິນຄ້າທົ່ວໄປ"
            background={
              activeProductTab === "PRODUCT" ? LINEAR_GRADIENT_BG : "#E5E7EB"
            }
            onClick={() => {
              const cartType = getActiveCartType();
              if (cartType === "VARIANT") {
                errorSwal("ກຳລັງໃຊ້ສິນຄ້າຫຼາຍຄ່າ ບໍ່ສາມາດສະຫຼັບໄປສິນຄ້າທົ່ວໄປ");
                return;
              }
              setActiveProductTab("PRODUCT");
              setPageNumber(1);
            }}
          />
          <CustomButton
            height={36}
            width={180}
            borderRadius={8}
            title="ສິນຄ້າຫຼາຍຄ່າ"
            background={
              activeProductTab === "VARIANT" ? LINEAR_GRADIENT_BG : "#E5E7EB"
            }
            onClick={() => {
              const cartType = getActiveCartType();
              if (cartType === "PRODUCT") {
                errorSwal("ກຳລັງໃຊ້ສິນຄ້າທົ່ວໄປ ບໍ່ສາມາດສະຫຼັບໄປສິນຄ້າຫຼາຍຄ່າ");
                return;
              }
              setActiveProductTab("VARIANT");
              setVariantPageNumber(1);
            }}
          />
        </div>
        <div className="purchaseorders-headers" style={{ marginTop: "1em" }}>
          <div style={{ width: "100%" }}>
            <InputGroup>
              <InputGroup.Text
                style={{
                  backgroundColor: "#FFFFFF",
                }}>
                <SearchIcon sx={{ color: "#6B7280" }} />
              </InputGroup.Text>
              <Form.Control
                placeholder="ຄົ້ນຫາສິນຄ້າ..."
                aria-describedby="basic-addon2"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                value={searchText}
                style={{
                  borderLeft: "none",
                  // width: '420px',
                  // maxWidth: '420px'
                }}
              />
            </InputGroup>
          </div>
          <div style={{ width: "50%", paddingLeft: "10px" }}>
            <Form.Select
              style={{
                height: "40px",
                // width: '266px',
                color: "#6B7280",
                cursor: "pointer",
              }}
              onChange={(e) => {
                setSearchCategory(e.target.value);
                localStorage.setItem("CURRENT_CATEGORY", e.target.value);
                localStorage.removeItem("CURRENT_BRAND");
                setSearchBrand();
              }}
              value={searchCategory}>
              <option value="ALL">ປະເພດທັງໝົດ</option>
              {category?.map((categorys) => (
                <option key={categorys.id} value={categorys?.id}>
                  {categorys?.name}
                </option>
              ))}
            </Form.Select>
          </div>
          <div style={{ width: "50%", paddingLeft: "10px" }}>
            <Form.Select
              style={{
                height: "40px",
                color: "#6B7280",
                cursor: "pointer",
              }}
              onChange={(e) => {
                setSearchBrand(e.target.value);
                localStorage.setItem("CURRENT_BRAND", e.target.value);
              }}
              value={searchBrand}>
              <option value="ALL">ເເບຣນທັງໝົດ</option>
              {brand?.map((brands, index) => (
                <option key={brands + index} value={brands?.id}>
                  {brands?.name}
                </option>
              ))}
            </Form.Select>
          </div>
          <div style={{ display: "flex", gap: 10, paddingLeft: "10px" }}>
            <CustomButton
              disabled={totalAmount <= 0 ? true : false}
              height={40}
              width={150}
              borderRadius={8}
              title={`ສັ່ງຊື້ (${totalAmount})`}
              background={totalAmount <= 0 ? "gray" : LINEAR_GRADIENT_BG}
              onClick={() =>
                totalAmount <= 0
                  ? errorSwal("ກະລຸນາເລືອກສິນຄ້າກອ່ນ")
                  : SetshowOrderModal(true)
              }
            />
            <CustomButton
              disabled={totalAmount <= 0 ? true : false}
              height={40}
              background={totalAmount <= 0 ? "gray" : "red"}
              width={150}
              borderRadius={8}
              title={`ຍົກເລີກ`}
              onClick={() =>
                totalAmount <= 0
                  ? ""
                  : _setNewCartData()
              }
            />
            
          </div>
        </div>

        <div className="purchaseorders-content">
          <Table
            hover
            style={{
              marginTop: "20px",
              borderCollapse: "collapse",
              width: "100% ",
              cursor: "pointer",
              borderRadius: "20px",
            }}>
            <thead
              style={{
                background: LINEAR_GRADIENT_BG,
                borderRadius: " 8px 8px 0px 0px",
                color: "#FFFFFF",
              }}>
              {activeProductTab === "PRODUCT" ? (
                <tr>
                  <th>ລ/ດ</th>
                  <th>ຊື່ສິນຄ້າ</th>
                  <th>ລະຫັດບາໂຄດ</th>
                  <th>ປະເພດສິນຄ້າ</th>
                  <th>ແບຣນສິນຄ້າ</th>
                  <th>ຈຳນວນ</th>
                  <th>ຫົວໜ່ວຍ</th>
                  <th>ລາຄາຕົ້ນທືນ</th>
                  <th>ລາຄາຂາຍ</th>
                  <th>ສະກຸນເງີນ</th>
                </tr>
              ) : (
                <tr>
                  <th>ລ/ດ</th>
                  <th>ຊື່ສິນຄ້າ</th>
                  <th>ຕົວເລືອກ</th>
                  <th>ປະເພດສິນຄ້າ</th>
                  <th>ແບຣນສິນຄ້າ</th>
                  <th>ຈຳນວນ</th>
                  <th>ລາຄາຕົ້ນທືນ</th>
                  <th>ລາຄາຂາຍ</th>
                  <th>ສະກຸນເງີນ</th>
                </tr>
              )}
            </thead>

            {activeProductTab === "PRODUCT" ? (
              productLoading && !productDatas ? (
                <tbody>
                  <tr>
                    <td colSpan={10}>
                      <AnimationLoading />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <>
                  {filteredProducts?.length > 0 ? (
                    <tbody>
                      {filteredProducts?.map((product, pindex) => (
                        <tr
                          key={product?.id || pindex}
                          onClick={() => onSelectProduct(product)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: checkedProductSelected(product)
                              ? "#6B7280"
                              : "#FFF",
                            color: checkedProductSelected(product)
                              ? "white"
                              : "",
                          }}>
                          <td style={{ paddingTop: "1rem" }}>
                            {pindex + 1 + LIMIT_PAGE * (pageNumber - 1)}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {product?.name ?? "-"}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {product?.barCode}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {product?.category?.name ?? product?.categoryName ?? "-"}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {product?.brand?.name ?? product?.brandName ?? "-"}
                          </td>
                          <td
                            style={{
                              paddingTop: "1rem",
                              color: product?.amount <= 0 ? "red" : "",
                              fontWeight: product?.amount <= 0 ? "bold" : "",
                            }}>
                            {numberFormat(product?.amount)}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {product?.unitIdId?.name}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {numberFormat(product?.originPrice)}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {numberFormat(
                              product?.priceOptions[0]?.price ??
                              product?.price ??
                              0
                            ) +
                              "/" +
                              numberFormat(
                                product?.priceOptions[0]?.contain ?? 0
                              )}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {convertCurrency(product?.currency)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={10}>
                          <div
                            style={{
                              fontSize: "18px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#6B7280",
                              fontWeight: "400",
                              padding: "1.5rem 0",
                            }}>
                            <EmptyComponent />
                            <p>ຍັງບໍ່ມີລາຍການສິນຄ້າກະລຸນາໄປເພີ່ມສິນຄ້າກ່ອນ !!!</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </>
              )
            ) : productVariantLoading && !productVariantData ? (
              <tbody>
                <tr>
                  <td colSpan={9}>
                    <AnimationLoading />
                  </td>
                </tr>
              </tbody>
            ) : (
              <>
                {filteredVariants?.length > 0 ? (
                  <tbody>
                    {filteredVariants?.map((variant, vindex) => {
                        const isSelected = checkedProductSelected({ id: variant?.id });
                        const isOut = (variant?.amount ?? 0) <= 0;
                        return (
                          <tr
                            key={variant?.id || vindex}
                            onClick={() => onSelectVariant(variant)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: isSelected ? "#6B7280" : "#FFF",
                              color: isSelected ? "white" : "",
                            }}>
                            <td style={{ paddingTop: "1rem" }}>
                              {vindex + 1 + LIMIT_PAGE * (variantPageNumber - 1)}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {variant?.product?.name ?? "-"}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {formatVariantAttributes(variant?.attributeValues)}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {variant?.product?.category?.name ?? "-"}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {variant?.product?.brandName ?? "-"}
                            </td>
                            <td
                              style={{
                                paddingTop: "1rem",
                                color: isOut ? "red" : "",
                                fontWeight: isOut ? "bold" : "",
                              }}>
                              {numberFormat(variant?.amount ?? 0)}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {numberFormat(variant?.originPrice ?? 0)}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {numberFormat(variant?.price ?? 0)}
                            </td>
                            <td style={{ paddingTop: "1rem" }}>
                              {convertCurrency(variant?.currency)}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={9}>
                        <div
                          style={{
                            fontSize: "18px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#6B7280",
                            fontWeight: "400",
                            padding: "1.5rem 0",
                          }}>
                          <EmptyComponent />
                          <p>ຍັງບໍ່ມີລາຍການສິນຄ້າກະລຸນາໄປເພີ່ມສິນຄ້າກ່ອນ !!!</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </>
            )}
          </Table>
        </div>
      </div>
      <div>
        <ReactPaginate
          previousLabel="ກັບຄືນ"
          onPageChange={(e) => {
            if (activeProductTab === "PRODUCT") {
              setPageNumber(e.selected + 1);
            } else {
              setVariantPageNumber(e.selected + 1);
            }
          }}
          breakLabel="..."
          pageRangeDisplayed={2}
          pageCount={
            Math.ceil(
              (activeProductTab === "PRODUCT"
                ? totalProduct
                : totalVariantProduct) / LIMIT_PAGE
            )
          }
          // pageRangeDisplayed={7}
          marginPagesDisplayed={2}
          renderOnZeroPageCount={null}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          forcePage={
            activeProductTab === "PRODUCT"
              ? pageNumber - 1
              : variantPageNumber - 1
          }
          nextLabel="ຕໍ່ໄປ"
        />
      </div>

      <PurchaseModal
        SetshowOrderModal={SetshowOrderModal}
        showOrderModal={showOrderModal}
        cartDatas={cartDatas}
        setCartDatas={setCartDatas}
        totalAmount={totalAmount}
        updateOrder={updateOrder}
        updateOrderGroup={updateOrderGroup}
        onClearOrder={onClearOrder}
        handleEditPriceProduct={handleEditPriceProduct}
        onCreateManyPurchaseOrderWithPurchaseOrderDetail={
          onCreateManyPurchaseOrderWithPurchaseOrderDetail
        }
        createPurchaseorderLoading={createPurchaseorderLoading || createManyPurchaseV2Loading}
      />
    </React.Fragment>
  );
}
